import { createAction } from '@reduxjs/toolkit';

import type { SessionData } from '../types/session';

export const resetSession = createAction<SessionData>('session/resetSession');
